import React from 'react';
import {Box, MenuItem, TextField, Typography} from '@mui/material';

import {TAG_TYPE} from '../../helpers/TagHelper';
import {toTitleCase} from '../../helpers/TextUtils';

const styles = {
    box: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '0.5rem',
        }
    },
};

export default function CategorySelect({value, onChange}) {
    const tagTypes = Object.values(TAG_TYPE);

    return (
        <Box sx={styles.box.container}>
            <TextField
                select
                value={value}
                onChange={onChange}
                fullWidth
                label="Category">
                {tagTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                        {toTitleCase(type)}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
}